// extracted by mini-css-extract-plugin
module.exports = {"root":"PlantManagement_root__c3K40","container":"PlantManagement_container__1DCp6","menu_user":"PlantManagement_menu_user__2-M5u","content":"PlantManagement_content__Oba_t"};